// extracted by mini-css-extract-plugin
export default {"ckDescription":"BlogsDetail_ckDescription__5mooC"};